<template>
  <div class="content">
    <div class="rotation">
      <div class="rotation_content">
        <el-form ref="form" :model="form" label-width="120px" :rules="rules" class="change_password_form">
          <el-form-item label="旧密码" prop="old_password">
            <el-input v-model="form.old_password" type="password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="新密码"  prop="new_password">
            <el-input v-model="form.new_password" type="password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认新密码"  prop="confirm_password">
            <el-input v-model="form.confirm_password"  @blur="blurNewP" type="password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item >
            <el-button type="primary"  @click="submitPssword">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: '',
    data(){
      return {
        form:{
          old_password:'',
          new_password:'',
          confirm_password:''
        },
        rules: {
          old_password: [
            { required: true, message: '请输入旧密码', trigger: 'blur' },
          ],
          new_password: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
          ],
          confirm_password: [
            { required: true, message: '请输入确认新密码', trigger: 'blur' },
          ],
        }
      }
    },
    created(){
      
    },
    mounted(){
      
    },
    methods: {
      blurNewP(){
        if(this.form.confirm_password != this.form.new_password){
          this.$message.error('确认密码错误请重新输入！')
          this.form.confirm_password  = ''
        }
      },
      submitPssword(){
        let params = {
          old_password:this.form.old_password,
          new_password:this.form.new_password,
          confirm_password:this.form.confirm_password
        }

        this.$api.user.resetPwd(params)
        .then(res=>{
          if(res.code === 0){
            this.$message.error('修改密码成功，请重新登录')
            this.$store.commit('deleInfo')
            this.$store.commit('deleteConfig')
            this.$store.commit('deleteRouters')
            this.$store.commit('deleteProvince')
            localStorage.clear()
            this.$router.replace({
              path:'/'
            })
          }
        }) 
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '../../assets/scss/content.scss';
  @import '../../assets/scss/userCenter.scss';
</style>